import React from 'react';
import { usePathname } from 'next/navigation';
import * as S from './Header.styles';
import { HeaderProps } from './Header.types';
import { HeaderLeftAction } from './components/HeaderLeftAction';
import { HeaderTitle } from './components/HeaderTitle';
import { DesktopHeaderCatalogue } from './components/DesktopHeaderCatalogue';
import { HeaderRightAction } from './components/HeaderRightAction';
import NoSsr from '@/components/NoSsr/NoSsr';
import { useResponsive } from '@/hooks/useResponsive';
import { CommonTestIds } from '@/__e2e__/testIds/common';
import { ROUTES } from '@/constants/routes';
import { SearchPanel } from '@/components/SearchPanel';
import { usePageType } from '@/hooks/usePageType/usePageType';
import { PageType } from '@/hooks/usePageType/usePageType.types';

export const Header = ({
  title,
  isMain,
  content,
  hasBurger,
  hasAddNew,
  rightAction,
  className,
  isServerRendered = true,
}: HeaderProps) => {
  const { isDesktop } = useResponsive();
  const pathname = usePathname();
  const pageType = usePageType();

  const Wrapper = isServerRendered ? React.Fragment : NoSsr;
  const hasCatalogueAndSearchPanel =
    isDesktop &&
    ![PageType.NewAd, PageType.EditAd].includes(pageType) &&
    pathname !== ROUTES.businessLanding;

  return (
    <S.HeaderBox $isMain={isMain} className={className}>
      <S.HeaderContent data-testid={CommonTestIds.header.box} $isMain={isMain}>
        <Wrapper>
          <HeaderLeftAction hasBurger={isMain || hasBurger} />
          {content || <HeaderTitle title={title} />}
          {hasCatalogueAndSearchPanel && (
            <>
              <DesktopHeaderCatalogue />
              <SearchPanel />
            </>
          )}
          <HeaderRightAction
            isMain={isMain}
            hasAddNew={hasAddNew}
            rightAction={rightAction}
          />
        </Wrapper>
      </S.HeaderContent>
    </S.HeaderBox>
  );
};
